import React from 'react'

function Footer() {
  return (
    <div className='w-full bg-[#007399] text-white'>
        <div className='w-full container mx-auto py-10 p-5 md:px-0'>
            <div className='flex flex-col gap-10'>

                <h2 className='font-bold text-2xl'>
                    ReportesComerciales.CL
                </h2>
                <p>
                Simplifica tu cobranza con herramientas avanzadas para recuperar deudas.
                </p>
                <p>
                    Automatiza y gestiona con eficiencia con informes interactivos.
                </p>

                <p>
                    @2025 ReportesComerciales.<br/>
                    Creado por <a href='https://awna.cl' className='underline'>
                    Awna Consultora Digital
                    </a>
                </p>

            </div>
        </div>
    </div>
  )
}

export default Footer